"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTES = void 0;
const ROUTES = exports.ROUTES = {
  Batch: "/batch",
  ComponentImport: "/component_import",
  ComponentTypeImport: "/component_type_import",
  Components: "/components",
  FileType: "/file_type",
  FileImporter: "/file_importer",
  FingerPrinter: "/finger_printer",
  Home: "/home",
  Logs: "/logs",
  LogsSettings: "/logs_settings",
  Product: "/product",
  ProductImport: "/product_import",
  Part: "/part",
  PartComposition: "/part_composition",
  Role: "/roles",
  SystemSettings: "/system_settings",
  LoginSettings: "/login_settings",
  UploadFile: "/upload_file",
  UploadFileSettings: "/upload_file_settings",
  User: "/users",
  Language: "/user_language",
  Login: "/login",
  AppRoot: "/auth",
  AppRoot2: "/auth2",
  LDAPAuthenticatorSettings: "/authenticator_Settings",
  RemoteAuthenticatorSettings: "/remote_authenticator_Settings",
  NotFound: "/not_found",
  UnderDevelopment: "/under_development",
  PartTable: "/part_table",
  ProductionOrder: "/production_order",
  RouteList: "/route_list",
  USBComponent: "/usb_component",
  SystemMonitor: "/system_monitor",
  Recipe: "/recipe"
};